import localforage from 'localforage'

const db = localforage.createInstance({
 name: 'erp-offline',
 storeName: 'cache',
})

export type CacheKey =
 | 'categories'
 | 'products'
 | 'customers'
 | 'suppliers'
 | 'purchases'
 | 'sales'
 | 'users'
 | 'employees'
 | 'payments'
 | 'notifications'
 | 'expenses'
 | 'deliveries'
 | 'deliveryZones'
 | 'deliveryTracking'
 | 'deliveryTrackingToday'
 | 'activeDrivers'
 | 'giftCards'
 | 'deliveryFinance'
 | 'financeDashboard'
 | 'financeLiabilities'
 | 'financeSettlements'
 | 'financeAlerts'
 | 'financeDriverDetail'
 | 'driverSettlements'

export async function setCache<T>(key: CacheKey, data: T): Promise<void> {
 await db.setItem(key, { data, cachedAt: Date.now() })
}

export async function getCache<T>(key: CacheKey): Promise<{ data: T; cachedAt: number } | null> {
 const item = await db.getItem<{ data: T; cachedAt: number }>(key)
 return item ?? null
}

export async function removeCache(key: CacheKey): Promise<void> {
 await db.removeItem(key)
}

export async function clearAllCache(): Promise<void> {
 await db.clear()
}

export async function getAllCacheKeys(): Promise<CacheKey[]> {
 const keys: string[] = []
 await db.iterate((_value, key) => {
 keys.push(key)
 })
 return keys as CacheKey[]
}
